// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_revokeSubuserInvitation(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "SubuserInvitationFailed",
    "SubuserInvitationRevoked"
  ]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"revokeSubuserInvitation_SubuserInvitationRevoked_account":{"f":""},"revokeSubuserInvitation":{"u":"response_revokeSubuserInvitation"}}};

let wrapResponseConverterMap = {
  response_revokeSubuserInvitation: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"revokeSubuserInvitation_SubuserInvitationRevoked_account":{"f":""},"revokeSubuserInvitation":{"u":"response_revokeSubuserInvitation"}}};

let responseConverterMap = {
  response_revokeSubuserInvitation: unwrap_response_revokeSubuserInvitation
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subuserLimitReached",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "SubuserInvitationFailed",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubuserPendingInvitationsRevokeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "revokeSubuserInvitation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountV5",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SubuserPendingInvitations_account"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "SubuserInvitationRevoked",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubuserPendingInvitationsRevokeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "revokeSubuserInvitation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountV5",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SubuserInvitation",
                    "kind": "LinkedField",
                    "name": "pendingSubuserInvitations",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "role",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "SubuserInvitationRevoked",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "890a059dada9bd7a9f90f33a69f14dd1",
    "id": null,
    "metadata": {},
    "name": "SubuserPendingInvitationsRevokeMutation",
    "operationKind": "mutation",
    "text": "mutation SubuserPendingInvitationsRevokeMutation(\n  $id: ID!\n) {\n  revokeSubuserInvitation(id: $id) {\n    __typename\n    ... on SubuserInvitationRevoked {\n      account {\n        subuserLimitReached\n        ...SubuserPendingInvitations_account\n        nodeId\n      }\n    }\n    ... on SubuserInvitationFailed {\n      message\n    }\n  }\n}\n\nfragment SubuserPendingInvitations_account on AccountV5 {\n  pendingSubuserInvitations {\n    id\n    firstName\n    lastName\n    email\n    role\n  }\n}\n"
  }
};
})());

let wrap_response_revokeSubuserInvitation = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_revokeSubuserInvitation = unwrap_response_revokeSubuserInvitation;
exports.wrap_response_revokeSubuserInvitation = wrap_response_revokeSubuserInvitation;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
